import * as React from 'react';
import {Helmet} from "react-helmet";
import HeroTextOnRightBlock from "../layouts/hero-text-on-right-block/hero-text-on-right-block";
import FullWidthImageOnLeftBlock from "../layouts/full-width-image-on-left-block/full-width-image-on-left-block";
import FullWidthImageOnRightBlock from "../layouts/full-width-image-on-right-block/full-width-image-on-right-block";
import TitleBlock from "../layouts/title-block/title-block";
import IntroStepBlock from "../layouts/intro-step-block/intro-step-block";
import TestimonialBlock from "../layouts/testimonial-block/testimonial-block";
import FeaturesBoxSimpleBlock from "../layouts/features-box-simple-block/features-box-simple-block";
import AchievementsCounterBlock from "../layouts/achievements-counter-block/achievements-counter-block";
import PromoBlock from "../layouts/promo-block/promo-block";
import RightTriangleInfoBlock from "../layouts/right-triangle-info-block/right-triangle-info-block";
import FaqBlock from "../layouts/faq-block/faq-block";
import PackageComparisonBlock from "../layouts/package-comparison-block/package-comparison-block";
import ProofBarBlock from "../layouts/proof-bar-block/proof-bar-block";
import {PageType, PromoBlockType} from "../models/types";
import { GoogleAnalyticsEventType } from "../models/google-analytics";
import * as helmetData from "../constants/helmet-data";
import * as staticUrls from "../constants/static-urls";
import * as staticImages from "../constants/static-images";
import * as featuresData from "../constants/features-data";
import * as testimonialsData from "../constants/testimonials-data";
import * as cacheBustingService from "../services/cache-busting-service";
import * as faqQuestionsData from "../constants/faq-questions-data";
import * as companyData from "../constants/company-data";

// Please note that you can use https://github.com/dotansimha/graphql-code-generator
// to generate all types from graphQL schema
interface IndexPageProps {
  data: {
    site: {
      siteMetadata: {
        title: string
      }
    }
  }
}

class IndexPage extends React.Component<IndexPageProps, {}> {

  componentDidMount() {
    cacheBustingService.handleCacheBusting(caches);
  }

  render() {
    return (
      <div>
        <Helmet {...helmetData.prepareHelmetData(PageType.LandingPage)}/>

        <HeroTextOnRightBlock
          titleLine1={"Pełna księgowość online"}
          titleLine2={"dla spółek z o.o. i p.s.a."}
          description={[
            "Prowadź księgowość spółki w łatwy i przemyślany sposób, oszczędzaj czas i pieniądze.",
            "Program jest stworzony dla mikro spółek z o.o. i prostych spółek akcyjnych, dlatego jest uproszczony pod ich potrzeby.",
            "Od 95 zł netto/mies., bez abonamentu i bez zobowiązań. A gdy czegoś nie wiesz, podpowiemy."
          ]}
          buttonText={"Czym jest Fakturomania?"}
          buttonLink={"https://pomoc.fakturomania.pl/support/solutions/articles/36000129929-czym-jest-fakturomania-"}
          buttonLinkIsForScrolling={false}
          backgroundImage={staticImages.PIGGY_BANK_BACKGROUND_IMAGE}
          componentViewEventType={GoogleAnalyticsEventType.LandingPageViewedMainTitleBlock}
          buttonClickEventType={GoogleAnalyticsEventType.LandingPageClickedCTAButtonAtMainTitleBlock}
        />

        <ProofBarBlock
          proofs={[
            {iconClassName: "fa fa-calendar", text: companyData.FAKTUROMANIA_PROOF_SINCE},
            {iconClassName: "fa fa-users", text: companyData.FAKTUROMANIA_PROOF_COMPANIES},
            {iconClassName: "fa fa-google", text: companyData.FAKTUROMANIA_PROOF_GOOGLE_RATING, link: staticUrls.FAKTUROMANIA_GOOGLE_OPINIE_URL}
          ]}
        />

        <TitleBlock
          id={"korzysci-spolki"}
          firstLineBlackStart={"To"}
          firstLineBlue={"prostsze,"}
          firstLineBlackEnd={"niż myślisz"}
          secondLineText={
            [
              "Z Fakturomanią wszystko masz pod ręką – wystawiasz faktury, prowadzisz księgowość i masz pełną kontrolę nad finansami swojej firmy w jednym, wygodnym systemie księgowym. Koniec z rozproszonymi narzędziami i skomplikowanymi procesami – teraz działasz szybciej, prościej i bezpieczniej.",
              "Nie komplikujemy – tłumaczymy, upraszczamy i automatyzujemy. Program jest stworzony dla małych spółek z o.o. i prostych spółek akcyjnych, więc jest uproszczony pod ich potrzeby. Tworzymy narzędzie, którego sami używamy.",
              "W aplikacji masz czat, w którym asystent AI odpowie od razu, o każdej porze, a jeśli wolisz albo sprawa jest trudniejsza, to porozmawiasz z księgowym serwisu.",
              "Spółka to nowe możliwości."
            ]
          }
        />

        <RightTriangleInfoBlock/>

        <IntroStepBlock
          steps={[
            {
              elementNumber: 1,
              elementNumberColor: "lightgray",
              elementTitle: "BRAK ZUS",
              elementText: "Masz wybór. To do Ciebie należy decyzja czy sp. z o.o. albo p.s.a podlega pod ZUS - po prostu."
            },
            {
              elementNumber: 2,
              elementNumberColor: "blue",
              elementTitle: "NISKIE PODATKI",
              elementText: "Jeżeli roczne obroty spółki nie przekraczają kwoty 2 mln euro, to spółka stosuje stawkę 9% CIT."
            },
            {
              elementNumber: 3,
              elementNumberColor: "green",
              elementTitle: "PROSTA KSIĘGOWOŚĆ",
              elementText: "Która jest dostępna tylko dla mikroprzedsiębiorców - spółek prowadzonych w Polsce."
            }
          ]}
          componentViewEventType={GoogleAnalyticsEventType.LandingPageViewedIntroStepBlock}
        />

        <FullWidthImageOnLeftBlock
          blockTitlePart1Black={"Istotne "}
          blockTitlePart2Blue={"Oszczędności"}
          blockTitlePart3Black={""}
          blockSubtitle={
            [
              `Ile więc można zyskać w ${companyData.FAKTUROMANIA_CURRENT_YEAR}`
            ]
          }
          numberBoxParagraphs={[
            "Spółka z o.o. lub p.s.a. pozwoli Ci ograniczyć koszty ZUS, to ponad 1900 zł miesięcznie. W roku to kwota co najmniej kilkunastu tysięcy złotych.",
            "Stawka podatku 9% CIT to oszczędność względem pozostałych form zarobkowania w Polsce, zwłaszcza względem JDG.",
            "Księgowość online z Fakturomanią pozwala znacząco ograniczyć koszty rozliczenia. To kolejne kilkaset złotych miesięcznie, które pozostaje w Twojej firmie.",
            "Ale to nie wszystko, zalet jest znacznie więcej."
          ]}
          odometers={[
            {
              odometerTitle: "OSZCZĘDNOŚĆ ZUS",
              odometerStart: 0,
              odometerEnd: 1982,
              odometerSuffix: " zł / mc",
              odometerDuration: 7
            },
            {
              odometerTitle: "STAWKA CIT",
              odometerStart: 19,
              odometerEnd: 9,
              odometerSuffix: "%",
              odometerDuration: 5
            },
            {
              odometerTitle: "NIŻSZE KOSZTY KSIĘGOWOŚCI",
              odometerStart: 0,
              odometerEnd: 700,
              odometerSuffix: " zł / mc",
              odometerDuration: 7
            },
            {
              odometerTitle: "ŚREDNIA OSZCZĘDNOŚĆ",
              odometerStart: 0,
              odometerEnd: 2682,
              odometerSuffix: " zł / mc",
              odometerDuration: 5
            }
          ]}
          componentViewEventType={GoogleAnalyticsEventType.LandingPageViewedOdometersBlock}
        />

        <TitleBlock
          firstLineBlackStart={"Program do"}
          firstLineBlue={"pełnej księgowości"}
          firstLineBlackEnd={"spółki z o.o."}
          secondLineText={
            [
              "Fakturomania to program do pełnej księgowości online spółki z o.o. i p.s.a. Prowadzisz w nim księgowość, wystawiasz faktury z integracją z KSeF, wysyłasz deklaracje podatkowe z plikami JPK i przygotowujesz sprawozdanie finansowe.",
              "Nasza aplikacja jest intuicyjna i prosta w obsłudze, zawiera bogatą bazę wiedzy, ale co najważniejsze, wsparcie techniczne i księgowe.",
              "Odbieramy, odpisujemy, tłumaczymy — codziennie pomagamy użytkownikom w pierwszych krokach i bardziej zawiłych sytuacjach.",
              "Jesteśmy po to, żeby księgowość przestała być problemem."
            ]
          }
          paddingTop={0}
          paddingBottom={0}
        />
        <FeaturesBoxSimpleBlock
          features={featuresData.STANDARD_APP_FEATURES}
          componentViewEventType={GoogleAnalyticsEventType.LandingPageViewedFeaturesBlock}
          buttonClickEventType={GoogleAnalyticsEventType.LandingPageNavigatedToPackagesComparisonPage}
        />

        <FullWidthImageOnRightBlock
          blockTitlePart1Black={"Płacisz, kiedy potrzebujesz. "}
          blockTitlePart2Blue={"Wszystko pod kontrolą"}
          blockTitlePart3Black={""}
          blockSubtitle={
            [
              "Bez automatycznego odnawiania — kupujesz pakiet (miesiąc, kwartał, pół roku albo rok), kiedy go potrzebujesz.",
              "Sam decydujesz o płatnościach i na bieżąco widzisz, co dzieje się w księgowości spółki."
            ]
          }
          blockParagraphs={[
            "Fakturomania została zaprojektowana w taki sposób, aby każdy mógł samodzielnie prowadzić księgowość spółki, a księgowi nie musieli dokonywać żmudnych i kosztowych konfiguracji.",
            "Fakturomania to bardzo intuicyjny interfejs, rozbudowana baza wiedzy oraz zespół, który odpowie na Twoje pytania. Fakturomania daje realną pomoc, dla której otrzymania nie trzeba wykupywać jakichś specjalnych odrębnie płatnych pakietów.",
            "Robi się coś dobrze, albo nie robi się wcale. Nasz zespół specjalizuje się w spółkach, dlatego jesteśmy tak dobrzy w tym co robimy.",
            "Przekonaj się, jak prosta może być z nami pełna księgowość twojej spółki."
          ]}
          blockButtonText={"WYPRÓBUJ APLIKACJĘ"}
          blockButtonLink={staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL}
          componentViewEventType={GoogleAnalyticsEventType.LandingPageViewedDescriptionBlock}
          buttonClickEventType={GoogleAnalyticsEventType.LandingPageClickedCTAButtonAtDescriptionBlock}
        />

          <TitleBlock
              firstLineBlackStart={"Prowadź"}
              firstLineBlue={"spółkę"}
              firstLineBlackEnd={"z Fakturomanią"}
              secondLineText={"Zarządzaj swoją spółką bez stresu i straty czasu. Fakturomania to wsparcie księgowe dla spółek – całkowicie online, przejrzyście i bez zbędnych formalności."}
              paddingTop={100}
          />
          <FaqBlock
              faqQuestions={faqQuestionsData.MAIN_PAGE_FAQ_QUESTIONS}
              componentViewEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooViewedFaqBlock}
              faqQuestionReadEventType={GoogleAnalyticsEventType.ZakladanieSpolekZooReadFaqQuestion}
          />
          <TitleBlock
              firstLineBlackStart={"Co masz w"}
              firstLineBlue={"programie księgowym"}
              firstLineBlackEnd={"dla spółki"}
              secondLineText={"Nasz system księgowy to coś więcej niż tylko wystawianie faktur. To kompleksowe narzędzie, które automatyzuje, upraszcza i wspiera każdy etap pracy z księgowością – od ewidencji dokumentów, przez raportowanie, po rozliczenia podatkowe. Fakturomania to również baza wiedzy, w której można odnaleźć nawet takie materiały, które omawiają jak prowadzić księgowość, tak krok po kroku, od organizacji segregatora księgowego zaczynając, a na przygotowaniu, zatwierdzeniu oraz złożeniu sprawozdania finansowego kończąc."}
              paddingTop={100}
          />
          <PackageComparisonBlock/>

        <TitleBlock
          firstLineBlackStart={"Księgowość w "}
          firstLineBlue={"Fakturomanii"}
          firstLineBlackEnd={"w liczbach"}
          secondLineText={"Działamy już na rynku długi czas, mamy bogate doświadczenie, zaś system to owoc mądrej i przemyślanej pracy."}
        />
        <AchievementsCounterBlock
          counters={[
            {
              iconString: "watch",
              counterStart: 0,
              counterEnd: companyData.FAKTUROMANIA_YEARS_ON_MARET,
              counterDuration: 3,
              counterText: "LAT NA RYNKU"
            },
            {
              iconString: "person",
              counterStart: 0,
              counterEnd: 9,
              counterDuration: 5,
              counterText: "TYS. FIRM"
            },
            {
              iconString: "description",
              counterStart: 0,
              counterEnd: 11,
              counterDuration: 5,
              counterText: "MLN KSIĘGOWAŃ W SERWISIE"
            }
          ]}
          componentViewEventType={GoogleAnalyticsEventType.LandingPageViewedAchievementsBlock}
        />

        <PromoBlock
          promoBlockType={PromoBlockType.PromoBlockGrayBox}
          promoBlockTitle={"PO PROSTU SPRAWDŹ I WYPRÓBUJ FAKTUROMANIĘ DZIŚ"}
          promoBlockText={"Przekonaj się, jak prosta może być księgowość spółki."}
          promoBlockButtonText={"WYPRÓBUJ BEZPŁATNIE"}
          promoBlockLink={staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL}
        />

      </div>
    )
  }

}

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;

export default IndexPage


// WEBPACK FOOTER //
// ./src/pages/index.tsx